import React from "react";
import { Link } from "react-router-dom";
const NoMatch = () => {
  return (
    <div className="no-match">
      <h3>The page you are looking for is not here! </h3>
      <br />
      <div className="mx-4">
        <h4>
          {" "}
          Click{" "}
          <Link replace to="/">
            here
          </Link>{" "}
          to go back to home page.
        </h4>
      </div>
    </div>
  );
};
export default NoMatch;
